export const react_api = process.env.REACT_APP_API_URL;
export const version  = process.env.REACT_APP_VERSION;
//

export const timer_refresh_upload_status  = process.env.REACT_APP_TIMER_REFRESH_UPLOAD_STATUS;


